(() => {
  if (customElements.get('lumive-daily-countdown')) return;

  class LumiveDailyCountdown extends HTMLElement {
    constructor() {
      super();
      this.intervalId = null;
      this.refresh = this.refresh.bind(this);
    }

    connectedCallback() {
      this.hours = this.querySelector('[data-countdown-hours]');
      this.minutes = this.querySelector('[data-countdown-minutes]');
      this.seconds = this.querySelector('[data-countdown-seconds]');

      if (!this.hours || !this.minutes || !this.seconds) {
        this.hidden = true;
        return;
      }

      this.refresh();
      if (this.intervalId === null) {
        this.intervalId = window.setInterval(this.refresh, 1000);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }

    refresh() {
      const now = new Date();
      const midnight = new Date(now.getTime());
      // Calendar arithmetic preserves the visitor's local day across DST changes.
      midnight.setHours(24, 0, 0, 0);
      const remaining = Math.ceil((midnight.getTime() - now.getTime()) / 1000);

      if (!Number.isFinite(remaining) || remaining < 0) {
        this.hidden = true;
        return;
      }

      this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      this.minutes.textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      this.seconds.textContent = String(remaining % 60).padStart(2, '0');
      this.hidden = false;
    }
  }

  customElements.define('lumive-daily-countdown', LumiveDailyCountdown);
})();
